// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { codeBidiWarningPlugin } from '@atlaskit/editor-plugin-code-bidi-warning';
export type {
	CodeBidiWarningPlugin,
	CodeBidiWarningPluginOptions,
} from '@atlaskit/editor-plugin-code-bidi-warning';
